import { trace } from '@/shared/observability/tracing';

const SAFE_TAG_KEYS = new Set(['loggedIn', 'locationSlug']);

export const metrics = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    measure: (fn: () => Promise<any>, name: string, params: Record<string, string> = {}): Promise<any> => {
        const tags = Object.fromEntries(
            Object.entries(params).filter(([key]) => SAFE_TAG_KEYS.has(key)),
        );
        return trace(fn, name, tags);
    },
};
